"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Flex, FlexCenter, NumberDisplay, SpaceBetween, TextBody, TextBodySkeleton, Tooltip } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { BigNumber, bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { SwapDetailsProviderFeeItemFragment } from "./SwapDetailsProviderFeeItem.fragment";
export function SwapDetailsMarketplaceFeeItem(t0) {
  const $ = _c(22);
  const {
    swapRoute
  } = t0;
  const route = readFragment(SwapDetailsProviderFeeItemFragment, swapRoute);
  const t = useTranslations("wallet.SwapDetailsMarketplaceFeeItem");
  if (!route || route.__typename !== "SwapRoute") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsMarketplaceFeeItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const fromAssetPriceUsd = bn(route.pricePerFromAsset.usd);
  const marketplaceFeeUsd = BigNumber.sum(...route.costs.filter(_temp).map(_temp2));
  const marketplaceFeePercentage = fromAssetPriceUsd.isZero() ? bn(0) : marketplaceFeeUsd.div(fromAssetPriceUsd);
  if (marketplaceFeeUsd.isZero() || marketplaceFeeUsd.isNaN()) {
    return null;
  }
  const isFromSolana = route.pricePerFromAsset.token.chain.arch === "SVM";
  let t1;
  if ($[1] !== t) {
    t1 = t("openSeaFee");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isFromSolana || $[6] !== t) {
    t3 = isFromSolana && <Tooltip content={t("solanaOpenSeaFeeTooltip")}><Info size={16} /></Tooltip>;
    $[5] = isFromSolana;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <FlexCenter className="gap-1">{t2}{t3}</FlexCenter>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== marketplaceFeeUsd) {
    t5 = <TextBody className="font-mono" color="text-secondary">(<NumberDisplay display="usd" value={marketplaceFeeUsd} />)</TextBody>;
    $[11] = marketplaceFeeUsd;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      maximumFractionDigits: 2
    };
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== marketplaceFeePercentage) {
    t7 = <TextBody asChild={true}><NumberDisplay custom={t6} display="percent" value={marketplaceFeePercentage} /></TextBody>;
    $[14] = marketplaceFeePercentage;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <Flex className="gap-1.5">{t5}{t7}</Flex>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t8) {
    t9 = <SpaceBetween>{t4}{t8}</SpaceBetween>;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}
function _temp2(c_0) {
  return c_0.cost.usd;
}
function _temp(c) {
  return c.costType === "MARKETPLACE";
}
function SwapDetailsMarketplaceFeeItemSkeleton() {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsMarketplaceFeeItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("openSeaFee");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBodySkeleton className="w-[100px]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}